const contributorsUrl = "https://api.github.com/repos/zhravan/github-readme-quotes/contributors?";
const serverUrl = "https://github-readme-quotes-bay.vercel.app";

export { contributorsUrl, serverUrl };
